module.exports = __webpack_public_path__ + "img/200.9332f611.jpg";